import UserBonuses from './UserBonuses';

export default UserBonuses;
